export default __webpack_public_path__ + "static/media/login-pexels.c2af90cc.png";